/* eslint-disable import/prefer-default-export */
export const getPremiumPerks = state => {
  const data = state.promotions.premiumPerks;
  if (data) {
    return data;
  }
  return null;
};
